import { FacilityAttendanceSettingsDto } from '../../models/facilities/attendance-settings.model';
export const facilityAttendanceSettingsMock: FacilityAttendanceSettingsDto[] = [
  {
    id: 1,
    facilityId: '550e8400-e29b-41d4-a716-446655440000',
    clockInWindowBeforeShiftMinutes: 15,
    clockInWindowAfterShiftMinutes: 5,
    clockOutWindowBeforeShiftMinutes: 10,
    clockOutWindowAfterShiftMinutes: 20,
    mobileClockInEnabled: true,
    computerClockInEnabled: true,
    authorizedClockInRequired: false,
    requireContractorSignatureAtClockIn: true,
    notifyManagersAfterMinutes: 30,
    notifyContractorsAfterMinutes: 15,
    managerMissedClockNotifications: true,
    contractorMissedClockNotifications: true
  },
  {
    id: 2,
    facilityId: '6fa459ea-ee8a-3ca4-894e-db77e160355e',
    clockInWindowBeforeShiftMinutes: 10,
    clockInWindowAfterShiftMinutes: 10,
    clockOutWindowBeforeShiftMinutes: 5,
    clockOutWindowAfterShiftMinutes: 15,
    mobileClockInEnabled: false,
    computerClockInEnabled: true,
    authorizedClockInRequired: true,
    requireContractorSignatureAtClockIn: false,
    notifyManagersAfterMinutes: 20,
    notifyContractorsAfterMinutes: 10,
    managerMissedClockNotifications: true,
    contractorMissedClockNotifications: false
  },
  {
    id: 3,
    facilityId: '123e4567-e89b-12d3-a456-426614174000',
    clockInWindowBeforeShiftMinutes: 20,
    clockInWindowAfterShiftMinutes: 0,
    clockOutWindowBeforeShiftMinutes: 15,
    clockOutWindowAfterShiftMinutes: 30,
    mobileClockInEnabled: true,
    computerClockInEnabled: false,
    authorizedClockInRequired: true,
    requireContractorSignatureAtClockIn: true,
    notifyManagersAfterMinutes: 45,
    notifyContractorsAfterMinutes: 30,
    managerMissedClockNotifications: false,
    contractorMissedClockNotifications: true
  }
];
